import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { EmeraldError, EmeraldErrorModal } from '../../common/api/emerald-error';
import {
  CounterfeitCouponFraud,
  CouponMaxAllowedScans,
  CouponValueRequired,
  InvalidCoupon,
} from '../../common/helpers/error-code';
import { applyCartResponse } from '../../home-page/business-logic/common/apply-cart-response';
import { IAddCouponData } from '../dto/IAddCouponData';
import { addCoupon } from './service/coupon-services';

export const addCouponLineItem = async (data: IAddCouponData): Promise<void> =>
  addCoupon(data)
    .then(applyCartResponse)
    .catch((error): void => {
      switch (error.code) {
        case CouponValueRequired:
          throw new EmeraldError(
            CouponValueRequired,
            'CouponValueRequired handler not implemented',
          );
        case CounterfeitCouponFraud:
          throw new EmeraldErrorModal({
            type: EmeraldDialogTypes.Error,
            message: CounterfeitCouponFraud,
            subMessageArgs: { arg: data.scanData ?? '' },
          });
        case CouponMaxAllowedScans:
          throw new EmeraldErrorModal({
            type: EmeraldDialogTypes.Error,
            message: CouponMaxAllowedScans,
            subMessage: error.message,
          });
        case InvalidCoupon:
          throw new EmeraldErrorModal({
            type: EmeraldDialogTypes.Error,
            message: 'InvalidCoupon_Message',
            subMessage: 'InvalidCoupon_Sub_Message',
          });
        default:
          throw error;
      }
    });
